module.exports = __webpack_public_path__ + "static/img/BA@3x.7de36a63.jpg";